import React, {forwardRef, useImperativeHandle, useState} from "react";
import {IconClose} from "../../Icon";
import {t} from "i18next";
import {Modal} from "antd";
import {getImagePath} from "@/utils";

const DialogLicenseHelper = forwardRef((props, ref) => {
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog
    }))

    const [isShowDialog,setIsShowDialog] = useState(false);

    const onShowDialog = ()=>{
        setIsShowDialog(true);
    }

    return(
        <Modal width={521} zIndex={2005} bodyStyle={{height:`${420}px`}}
               open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null} onCancel={()=> {
            setIsShowDialog(false);
        }}>
            <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
                <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                    <span className={'dialog-title'}>{t("ActiveYourLicense")}</span>
                    <div style={{flexGrow: '1'}}/>
                </div>
                <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>

                <span className={'mt-12'} style={{color: 'var(--color-666666)'}}>{t("ActivateStep1")}</span>
                <span className={'mt-12'} style={{color: 'var(--color-666666)'}}>{t("ActivateStep2")}</span>
                <span className={'mt-12'} style={{color: 'var(--color-666666)'}}>{t("ActivateStep3")}</span>
                <img className={'mt-20'} style={{width: '474px', height: '244px'}} src={getImagePath('active_helper_step')}/>
            </div>
        </Modal>
    )
})

export default DialogLicenseHelper;